<template>
  <div class="form-group">
    <div class="input-group">
      <label
        v-if="label"
        :for="'input-' + name"
        class="control-label"
      >
        {{ label }}
      </label>
      <input
        :type="type"
        :value="value"
        :id="'input-' + name"
        :required="required"
        @input="$emit('input', $event.target.value)"
        @blur="$emit('blur', $event.target.value)"
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'FieldInput',

  props: {
    type: {
      required: false,
      type: String,
      default: 'text'
    },
    value: {
      required: false,
      type: [String, Number],
      default: ''
    },
    name: {
      required: true,
      type: [String, Number]
    },
    label: {
      required: false,
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    }
  }
}
</script>
